export const initialSignupRoute = [
  '/signup', "preferences", "1"
]

export const initialSignupRouteIncludingInfo = [
  '/signup', "start"
]


export const createAccountRoute = [
  '/signup', "create-account"
]
